const DEVICE_ID_KEY = 'ivs_board_games_device_id';

export function getDeviceId(storage = globalThis.localStorage, cryptoImpl = globalThis.crypto) {
  let id = storage?.getItem(DEVICE_ID_KEY);
  if (id) return id;

  id = cryptoImpl?.randomUUID
    ? cryptoImpl.randomUUID()
    : 'dev_' + Math.random().toString(36).slice(2, 11);

  storage?.setItem(DEVICE_ID_KEY, id);
  return id;
}
